import { render, staticRenderFns } from "./NewSystemGenerated.vue?vue&type=template&id=37367cee"
import script from "./NewSystemGenerated.vue?vue&type=script&lang=js"
export * from "./NewSystemGenerated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports